export enum AuthorizeStatus {
  Success = `success`,
  Fail = `fail`,
  Cancel = `cancel`,
}

export function openSlackOauthBroadcastChannel() {
  return new BroadcastChannel(`slack-oauth-loop-events`);
}
